export const parseCurrencyToNumber = (input?: string | number): number => {
  if (typeof input === 'number') {
    return input;
  }
  return parseFloat((input || '0').replace(/[$,]+/g, ''));
};
